import type { ReactNode } from 'react';
import styles from './StatPill.module.css';

interface StatPillProps {
  icon?: ReactNode;
  children: ReactNode;
  tone?: 'neutral' | 'ok' | 'warn';
}

/** A small outlined pill for a compact figure, e.g. "248h", "$52K", "GP 43%". */
export function StatPill({ icon, children, tone = 'neutral' }: StatPillProps): React.JSX.Element {
  return (
    <span className={`${styles.pill} ${styles[tone]}`}>
      {icon}
      {children}
    </span>
  );
}
